import { useTranslation } from 'react-i18next'
import { Check } from 'lucide-react'

const languages = [
  { id: 'en', label: 'English', flag: '🇬🇧' },
  { id: 'sv', label: 'Svenska', flag: '🇸🇪' },
]

interface LanguageStepProps {
  language: string
  onSelect: (lang: string) => void
}

export default function LanguageStep({ language, onSelect }: LanguageStepProps) {
  const { t } = useTranslation('onboarding')

  return (
    <div>
      <div className="text-center mb-6">
        <img src="/tendbot.png" alt="TendBot" className="h-14 w-auto mx-auto mb-3" />
        <h2 className="font-display text-2xl text-ivory font-semibold mb-1">{t('language.welcome')}</h2>
        <p className="text-pearl/50 text-sm">{t('language.subtitle')}</p>
      </div>

      <div className="space-y-3">
        {languages.map(lang => (
          <button
            key={lang.id}
            onClick={() => onSelect(lang.id)}
            className={`w-full glass-card rounded-xl p-4 flex items-center gap-4 transition-all ${
              language === lang.id
                ? 'border-gold/40 glow-gold'
                : 'border-transparent hover:border-gold/20'
            }`}
          >
            <span className="text-2xl">{lang.flag}</span>
            <span className={`text-sm font-medium ${
              language === lang.id ? 'text-ivory' : 'text-pearl/70'
            }`}>
              {lang.label}
            </span>
            {language === lang.id && (
              <Check size={14} className="text-gold ml-auto" />
            )}
          </button>
        ))}
      </div>
    </div>
  )
}
